import Action  from './baseActions';

// Types

export enum TableauActionTypes {
  LOAD_WORKBOOKS = 'tableau/load_workbooks',
  LOADING_WORKBOOKS = 'tableau/loading_workbooks',
  LOADED_WORKBOOKS = 'tableau/loaded_workbooks',
  LOADING_WORKBOOKS_FAILED = 'tableau/loading_workbooks_failed',
  UNSET_LOAD_WORKBOOKS_STATUS = 'tableau/unset_load_workbooks_status',
  UNSET_WORKBOOKS = 'tableau/unset_workbooks',

  LOAD_VIEWS = 'tableau/load_views',
  LOADING_VIEWS = 'tableau/loading_views',
  LOADED_VIEWS = 'tableau/loaded_views',
  LOADING_VIEWS_FAILED = 'tableau/loading_views_failed',
  UNSET_VIEWS = 'tableau/unset_views',

  LOAD_VIEW = 'tableau/load_view',
  LOADING_VIEW = 'tableau/loading_view',
  LOADED_VIEW = 'tableau/loaded_view',
  LOADING_VIEW_FAILED = 'tableau/loading_view_failed',
  UNSET_VIEW = 'tableau/unset_view',

  LOAD_VIEW_DATA = 'tableau/load_view_data',
  LOADING_VIEW_DATA = 'tableau/loading_view_data',
  LOADED_VIEW_DATA = 'tableau/loaded_view_data',
  LOADING_VIEW_DATA_FAILED = 'tableau/loading_view_data_failed',

  LOAD_CUSTOM_VIEWS = 'tableau/load_custom_views',
  LOADING_CUSTOM_VIEWS = 'tableau/loading_custom_views',
  LOADED_CUSTOM_VIEWS = 'tableau/loaded_custom_views',
  LOADING_CUSTOM_VIEWS_FAILED = 'tableau/loading_custom_views_failed',
  UNSET_CUSTOM_VIEWS = 'tableau/unset_custom_views',

  REQUEST_TRUSTED_TICKET = 'tableau/request_trusted_ticket',
  REQUEST_TRUSTED_TICKET_LOADING = 'tableau/request_trusted_ticket_loading',
  REQUEST_TRUSTED_TICKET_SUCCESS = 'tableau/request_trusted_ticket_success',
  REQUEST_TRUSTED_TICKET_FAILED = 'tableau/request_trusted_ticket_failed',

  UPLOAD_THUMBNAIL = 'tableau/upload_thumbnail',
  UPLOAD_THUMBNAIL_LOADING = 'tableau/upload_thumbnail_loading',
  UPLOAD_THUMBNAIL_SUCCESS = 'tableau/upload_thumbnail_success',
  UPLOAD_THUMBNAIL_FAILED = 'tableau/upload_thumbnail_failed',
  UPLOAD_THUMBNAIL_PROGRESS = 'tableau/upload_thumbnail_progress',
}

// Interfaces

export interface IUploadThumbnailAction extends Action {
  type: TableauActionTypes.UPLOAD_THUMBNAIL;
  payload: {
    integrationUid: string;
    blockUid: string;
    workspaceId: string;
    startTime: string;
    file: File;
  }
}

export interface IUploadingThumbnailAction extends Action {
  type: TableauActionTypes.UPLOAD_THUMBNAIL_LOADING;
}

export interface IUploadThumbnailSuccessAction extends Action {
  type: TableauActionTypes.UPLOAD_THUMBNAIL_SUCCESS;
  payload: {
    result: any;
  }
}

export interface IUploadThumbnailFailedAction extends Action {
  type: TableauActionTypes.UPLOAD_THUMBNAIL_FAILED;
  payload: {
    error: any;
  }
}

export interface IUploadThumbnailProgressAction extends Action {
  type: TableauActionTypes.UPLOAD_THUMBNAIL_PROGRESS;
  payload: {
    progress: number;
  }
}

export interface IRequestTrustedTicketAction extends Action {
  type: TableauActionTypes.REQUEST_TRUSTED_TICKET;
  payload: {
    integrationUid: string;
  }
}

export interface IRequestTrustedTicketLoadingAction extends Action {
  type: TableauActionTypes.REQUEST_TRUSTED_TICKET_LOADING;
}

export interface IRequestTrustedTicketSuccessAction extends Action {
  type: TableauActionTypes.REQUEST_TRUSTED_TICKET_SUCCESS;
  payload: {
    result: any;
    integrationUid: string;
  }
}

export interface IRequestTrustedTicketFailedAction extends Action {
  type: TableauActionTypes.REQUEST_TRUSTED_TICKET_FAILED;
  payload: {
    error: any;
  }
}

export interface ILoadWorkbooksAction extends Action {
  type: TableauActionTypes.LOAD_WORKBOOKS;
  payload: {
    blockUid: string;
    integrationUid: string;
    keyword?: string;
    /*
     * BUG FIX:
     *   In order to avoid a racing condition on the BE with loadWorkbooks and loadCustomViews
     *     being called at the same time and both trying to update `auth_token` resulting in a 401 auth error,
     *     we will call "custom views" after workbooks are loaded, if `loadCustomViews` is set to true
     *     (sequential loading instead of parallel).
     */
    loadCustomViews?: boolean;
  }
}

export interface ILoadingWorkbooksAction extends Action {
  type: TableauActionTypes.LOADING_WORKBOOKS;
}

export interface ILoadedWorkbooksAction extends Action {
  type: TableauActionTypes.LOADED_WORKBOOKS;
  payload: {
    result: any;
    blockUid: string; // used in order to know which block it belongs to
    integrationUid: string;
  }
}

export interface ILoadingWorkbooksFailedAction extends Action {
  type: TableauActionTypes.LOADING_WORKBOOKS_FAILED;
  payload: {
    error: any;
  }
}

export interface IUnsetLoadWorkbooksAction extends Action {
  type: TableauActionTypes.UNSET_LOAD_WORKBOOKS_STATUS;
  payload: null;
}

export interface IUnsetWorkbooksAction extends Action {
  type: TableauActionTypes.UNSET_WORKBOOKS;
}

export interface ILoadViewsAction extends Action {
  type: TableauActionTypes.LOAD_VIEWS;
  payload: {
    blockUid: string;
    integrationUid: string;
    workbookId: string;
    keyword?: string;
  }
}

export interface ILoadingViewsAction extends Action {
  type: TableauActionTypes.LOADING_VIEWS;
}

export interface ILoadedViewsAction extends Action {
  type: TableauActionTypes.LOADED_VIEWS;
  payload: {
    result: any;
    blockUid: string; // used in order to know which block it belongs to
    integrationUid: string;
    workbookId: string;
  }
}

export interface ILoadingViewsFailedAction extends Action {
  type: TableauActionTypes.LOADING_VIEWS_FAILED;
  payload: {
      error: any;
  }
}

export interface IUnsetViewsAction extends Action {
  type: TableauActionTypes.UNSET_VIEWS;
  payload: string; // blockUid
}

export interface ILoadViewAction extends Action {
  type: TableauActionTypes.LOAD_VIEW;
  payload: {
    blockUid: string;
    integrationUid: string;
    viewId: string;
  }
}

export interface ILoadingViewAction extends Action {
  type: TableauActionTypes.LOADING_VIEW;
}

export interface ILoadedViewAction extends Action {
  type: TableauActionTypes.LOADED_VIEW;
  payload: {
    result: any;
    blockUid: string; // used in order to know which block it belongs to
    integrationUid: string;
  }
}

export interface ILoadingViewFailedAction extends Action {
  type: TableauActionTypes.LOADING_VIEW_FAILED;
  payload: {
    error: any;
  }
}

export interface ILoadViewDataAction extends Action {
  type: TableauActionTypes.LOAD_VIEW_DATA;
  payload: {
    blockUid: string;
    integrationUid: string;
    viewId: string;
    action: string;
  }
}

export interface ILoadingViewDataAction extends Action {
  type: TableauActionTypes.LOADING_VIEW_DATA;
}

export interface ILoadedViewDataAction extends Action {
  type: TableauActionTypes.LOADED_VIEW_DATA;
  payload: {
    result: any;
    blockUid: string; // used in order to know which block it belongs to
    integrationUid: string;
  }
}

export interface ILoadingViewDataFailedAction extends Action {
  type: TableauActionTypes.LOADING_VIEW_DATA_FAILED;
  payload: {
    error: any;
  }
}

export interface IUnsetViewAction extends Action {
  type: TableauActionTypes.UNSET_VIEW;
  payload: {
    blockUid: string;
    viewId: string;
  }
}

export interface ILoadCustomViewsAction extends Action {
    type: TableauActionTypes.LOAD_CUSTOM_VIEWS;
    payload: {
      blockUid: string;
      integrationUid: string;
    }
}

export interface ILoadingCustomViewsAction extends Action {
    type: TableauActionTypes.LOADING_CUSTOM_VIEWS;
}

export interface ILoadedCustomViewsAction extends Action {
    type: TableauActionTypes.LOADED_CUSTOM_VIEWS;
    payload: {
        result: any;
        blockUid: string;
        integrationUid: string;
    }
}

export interface ILoadingCustomViewsFailedAction extends Action {
    type: TableauActionTypes.LOADING_CUSTOM_VIEWS_FAILED;
}

export interface IUnsetCustomViewsAction extends Action {
    type: TableauActionTypes.UNSET_CUSTOM_VIEWS;
    payload: string; // blockUid
}

// Functions

export function uploadThumbnail(integrationUid: string, blockUid: string, workspaceId: string, startTime: string, file: File): IUploadThumbnailAction {
  return {
    type: TableauActionTypes.UPLOAD_THUMBNAIL,
    payload: {
      integrationUid,
      blockUid,
      workspaceId,
      startTime,
      file,
    }
  };
}

export function uploadingThumbnail(): IUploadingThumbnailAction {
  return {
    type: TableauActionTypes.UPLOAD_THUMBNAIL_LOADING,
  };
}

export function uploadThumbnailSuccess(result: any): IUploadThumbnailSuccessAction {
  return {
    type: TableauActionTypes.UPLOAD_THUMBNAIL_SUCCESS,
    payload: {
      result,
    }
  };
}

export function uploadThumbnailFailed(error: any): IUploadThumbnailFailedAction {
  return {
    type: TableauActionTypes.UPLOAD_THUMBNAIL_FAILED,
    payload: {
      error,
    }
  };
}

export function uploadThumbnailProgress(progress: number): IUploadThumbnailProgressAction {
  return {
    type: TableauActionTypes.UPLOAD_THUMBNAIL_PROGRESS,
    payload: {
      progress,
    }
  };
}

export function requestTrustedTicket(integrationUid: string): IRequestTrustedTicketAction {
  return {
    type: TableauActionTypes.REQUEST_TRUSTED_TICKET,
    payload: {
      integrationUid,
    }
  };
}

export function requestTrustedTicketLoading(): IRequestTrustedTicketLoadingAction {
  return {
    type: TableauActionTypes.REQUEST_TRUSTED_TICKET_LOADING,
  };
}

export function requestTrustedTicketSuccess(integrationUid: string, result: string): IRequestTrustedTicketSuccessAction {
  return {
    type: TableauActionTypes.REQUEST_TRUSTED_TICKET_SUCCESS,
    payload: {
      integrationUid,
      result,
    }
  };
}

export function requestTrustedTicketFailed(error: any): IRequestTrustedTicketFailedAction {
  return {
    type: TableauActionTypes.REQUEST_TRUSTED_TICKET_FAILED,
    payload: {
      error,
    }
  };
}

export function loadWorkbooks(
  blockUid: string,
  integrationUid: string,
  keyword?: string,
  loadCustomViews?: boolean,
): ILoadWorkbooksAction {
  return {
    type: TableauActionTypes.LOAD_WORKBOOKS,
    payload: {
      blockUid,
      integrationUid,
      keyword,
      loadCustomViews: loadCustomViews || false,
    }
  };
}

export function loadingWorkbooks(): ILoadingWorkbooksAction {
  return {
    type: TableauActionTypes.LOADING_WORKBOOKS,
  };
}

export function loadedWorkbooks(result: any, blockUid: string, integrationUid: string): ILoadedWorkbooksAction {
  return {
    type: TableauActionTypes.LOADED_WORKBOOKS,
    payload: {
      result,
      blockUid,
      integrationUid,
    }
  };
}

export function loadingWorkbooksFailed(error: any): ILoadingWorkbooksFailedAction {
  return {
    type: TableauActionTypes.LOADING_WORKBOOKS_FAILED,
    payload: {
        error
    },
  };
}

export function unsetLoadWorkbooksStatus(): IUnsetLoadWorkbooksAction {
  return {
    type: TableauActionTypes.UNSET_LOAD_WORKBOOKS_STATUS,
    payload: null,
  };
}

export function unsetWorkbooks(): IUnsetWorkbooksAction {
  return {
    type: TableauActionTypes.UNSET_WORKBOOKS,
  };
}

export function loadViews(
  blockUid: string,
  integrationUid: string,
  workbookId: string,
  keyword?: string
): ILoadViewsAction {
  return {
    type: TableauActionTypes.LOAD_VIEWS,
    payload: {
      blockUid,
      integrationUid,
      workbookId,
      keyword,
    }
  };
}

export function loadingViews(): ILoadingViewsAction {
  return {
    type: TableauActionTypes.LOADING_VIEWS,
  };
}

export function loadedViews(
  result: any,
  blockUid: string,
  integrationUid: string,
  workbookId: string
): ILoadedViewsAction {
  return {
    type: TableauActionTypes.LOADED_VIEWS,
    payload: {
      result,
      blockUid,
      integrationUid,
      workbookId,
    }
  };
}

export function loadingViewsFailed(error: any): ILoadingViewsFailedAction {
  return {
    type: TableauActionTypes.LOADING_VIEWS_FAILED,
    payload: {
        error
    },
  };
}

export function unsetViews(blockUid: string): IUnsetViewsAction {
  return {
    type: TableauActionTypes.UNSET_VIEWS,
    payload: blockUid,
  };
}

export function loadView(blockUid: string, integrationUid: string, viewId: string): ILoadViewAction {
  return {
    type: TableauActionTypes.LOAD_VIEW,
    payload: {
      blockUid,
      integrationUid,
      viewId,
    }
  };
}

export function loadingView(): ILoadingViewAction {
  return {
    type: TableauActionTypes.LOADING_VIEW,
  };
}

export function loadedView(result: any, blockUid: string, integrationUid: string): ILoadedViewAction {
  return {
    type: TableauActionTypes.LOADED_VIEW,
    payload: {
      result,
      blockUid,
      integrationUid,
    }
  };
}

export function loadingViewFailed(error: any): ILoadingViewFailedAction {
  return {
    type: TableauActionTypes.LOADING_VIEW_FAILED,
    payload: {
        error
    }
  };
}

export function loadViewData(blockUid: string, integrationUid: string, viewId: string, action: string): ILoadViewDataAction {
  return {
    type: TableauActionTypes.LOAD_VIEW_DATA,
    payload: {
      blockUid,
      integrationUid,
      viewId,
      action,
    }
  };
}

export function loadingViewData(): ILoadingViewDataAction {
  return {
    type: TableauActionTypes.LOADING_VIEW_DATA,
  };
}

export function loadedViewData(result: any, blockUid: string, integrationUid: string): ILoadedViewDataAction {
  return {
    type: TableauActionTypes.LOADED_VIEW_DATA,
    payload: {
      result,
      blockUid,
      integrationUid,
    }
  };
}

export function loadingViewDataFailed(error: any): ILoadingViewDataFailedAction {
  return {
    type: TableauActionTypes.LOADING_VIEW_DATA_FAILED,
    payload: {
        error
    }
  };
}

export function unsetView(blockUid: string, viewId: string): IUnsetViewAction {
  return {
    type: TableauActionTypes.UNSET_VIEW,
    payload: {
      blockUid,
      viewId,
    }
  };
}

export function loadCustomViews(
    blockUid: string,
    integrationUid: string,
): ILoadCustomViewsAction {
    return {
        type: TableauActionTypes.LOAD_CUSTOM_VIEWS,
        payload: {
            blockUid,
            integrationUid,
        }
    };
}

export function loadingCustomViews(): ILoadingCustomViewsAction {
    return {
        type: TableauActionTypes.LOADING_CUSTOM_VIEWS,
    };
}

export function loadedCustomViews(
    result: any,
    blockUid: string,
    integrationUid: string,
): ILoadedCustomViewsAction {
    return {
        type: TableauActionTypes.LOADED_CUSTOM_VIEWS,
        payload: {
            result,
            blockUid,
            integrationUid,
        }
    };
}

export function loadingCustomViewsFailed(): ILoadingCustomViewsFailedAction {
    return {
        type: TableauActionTypes.LOADING_CUSTOM_VIEWS_FAILED,
    };
}

export function unsetCustomViews(blockUid: string): IUnsetCustomViewsAction {
    return {
        type: TableauActionTypes.UNSET_CUSTOM_VIEWS,
        payload: blockUid,
    };
}

export type TableauActions =
  | ILoadWorkbooksAction
  | ILoadingWorkbooksAction
  | ILoadedWorkbooksAction
  | ILoadingWorkbooksFailedAction
  | IUnsetLoadWorkbooksAction
  | IUnsetWorkbooksAction
  | ILoadViewsAction
  | ILoadingViewsAction
  | ILoadedViewsAction
  | ILoadingViewsFailedAction
  | IUnsetViewsAction
  | ILoadViewAction
  | ILoadingViewAction
  | ILoadedViewAction
  | ILoadingViewFailedAction
  | IUnsetViewAction
  | ILoadCustomViewsAction
  | ILoadingCustomViewsAction
  | ILoadedCustomViewsAction
  | ILoadingCustomViewsFailedAction
  | IUnsetCustomViewsAction
  | IRequestTrustedTicketAction
  | IRequestTrustedTicketLoadingAction
  | IRequestTrustedTicketSuccessAction
  | IRequestTrustedTicketFailedAction
  | IUploadThumbnailAction
  | IUploadingThumbnailAction
  | IUploadThumbnailSuccessAction
  | IUploadThumbnailFailedAction
  | ILoadViewDataAction
  | ILoadingViewDataAction
  | ILoadedViewDataAction
  | ILoadingViewDataFailedAction
  | IUploadThumbnailProgressAction;
